/* eslint-disable react/no-danger */
/* eslint-disable no-console */
import { Box, HStack, Skeleton, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import TextEditor from '~/components/TextEditor';
import { ApplicationState } from '~/store/store';
import { ProposalSectionProps } from '~/store/ducks/Proposal/types';
import ProposalService from '~/store/ducks/Proposal/services';
import { toastError, toastSuccess } from '~/helpers/toast';
import Warning from '~/components/Form/Warning';
import { Button } from '~/components/Form/Button/Button_Styles';

const ProposalOwners: React.FC<ProposalSectionProps> = ({ isExpanded }) => {
  const { id: projectId } = useSelector((state: ApplicationState) => state.project);
  const { data: proposalData } = useSelector((state: ApplicationState) => state.proposal);
  const [loading, setLoading] = useState<boolean>(false);
  const [proposalOwners, setProposalOwners] = useState(null);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [isTextModified, setIsTextModified] = useState<boolean>(false);

  const fetchProposalOwners = async () => {
    try {
      setLoading(true);
      const response = await ProposalService.getProposalOwners(projectId, proposalData.id);
      setProposalOwners(response.data);
    } catch (err) {
      console.error(err);
      toastError('proposal', 'Erro ao recuperar apresentação.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isExpanded) {
      fetchProposalOwners();
    }
    return () => setProposalOwners(null);
  }, [isExpanded]);

  const saveResposibleText = (markdown) => {
    setIsTextModified(true);
    setProposalOwners({
      ...proposalOwners,
      text: markdown,
    });
  };

  const handleSubmit = async () => {
    const body = { ...proposalOwners };

    try {
      setButtonLoading(true);
      const response = await ProposalService.saveProposalOwners(projectId, proposalData.id, body);
      toastSuccess('proposal', 'Salvo com sucesso!');
      setIsTextModified(false);
    } catch (err) {
      console.error(err);
      toastError('proposal', 'Erro ao salvar seção.');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <Skeleton isLoaded={!loading}>
      {proposalOwners && (
        <Box className="proposal__section">
          <Text className="proposal__text">
            {proposalOwners.template.text}
            {/* Estamos à disposição para maiores esclarecimentos, <br /> Atenciosamente, */}
          </Text>
          {/* <div
            className="proposal__text"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(markdownToHTMLConverter.makeHtml('')),
            }}
          /> */}
          <TextEditor markdown={proposalOwners.text} saveContentEditor={saveResposibleText} />
        </Box>
      )}
      {isTextModified && <Warning message="As alterações ainda não foram salvas." />}
      <HStack mt={5} justify="end">
        <Button isLoading={buttonLoading} disabled={!isTextModified} $primary onClick={handleSubmit}>
          Salvar
        </Button>
      </HStack>
    </Skeleton>
  );
};

export default ProposalOwners;
